import { css } from "@emotion/css";
import { theme } from "../../utils/theme";

export const historyItemToolbarCSS = css`
  width: 54px;

  & .spark-toolbar.show-more .spark-toolbar__show-more {
    width: 36px;
    height: 36px;
    padding: 0;
    visibility: hidden;

    i {
      font-size: 1.5rem;
    }
  }

  & .spark-toolbar {
    height: 36px;
  }
`;

export const historyItemCSS = css`
  display: flex;
  background: none;
  color: inherit;
  border: none;
  padding: 0 0 0 2rem;
  font: inherit;
  cursor: pointer;
  outline: inherit;
  text-align: left;
  height: 36px;
  position: relative;
  margin: 0;
  border-radius: 4px;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  .chat-history-button-label {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &.active {
    font-weight: 700;

    &:before {
      content: " ";
      position: absolute;
      left: 1px;
      top: 0;
      height: 36px;
      width: 6px;
      border-radius: 4px;
      background: linear-gradient(to right, #ff4545, #e50000, #bd0041);
    }
  }

  &:hover {
    background-color: ${theme.palette.gray[20]};

    & .spark-toolbar.show-more .spark-toolbar__show-more {
      visibility: visible;
    }
  }
`;
